import React from 'react';
import styled from 'styled-components';

const FeaturedPublicationsWrapper = styled.div`
    padding-top: 20px;
    max-width: 1920px;
    margin: 0 auto;

    @media (max-width: 995px) {
        font-size: 17px;
    }
`;

const SectionWrapper = styled.div`
    position: relative;
    text-align: center;
    padding: 0;
    
    @media (max-width: 995px) {
        padding: 0 0 40px;
    }

    @media (max-width: 700px) {
        padding: 0 10px 40px;
    }
`;

const TitleWrapper = styled.div`
    position: relative;
    margin-bottom: 10px;
    padding: 0 20px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 995px) {
        padding: 0;
    }
`;

const Title = styled.h4`
    color: ${p => p.titleColor};
    font-size: 24px;
    font-weight: 300;
    margin: 0;
    padding: 2px 10px;
    text-transform: uppercase;
    letter-spacing: 1px;
    z-index: 1;

    @media (max-width: 995px){
        font-size: 4.2vw;
        letter-spacing: 1px;
    }
`;

const Line = styled.div`
    flex: 1 1 auto;
    border-bottom: 1px solid ${p => p.lineColor};
    height: 0;
`;

const Logo = styled.img`
    width: 13%;
    display: inline-block;
    margin: 10px 20px;
    padding: 10px;
    ${p => p.logoFilter ? `filter: ${p.logoFilter};` : ''}

    @media (max-width: 1200px) {
        width: 22%;
        margin: 10px;
    }
    
    @media (max-width: 995px) {    
        width: 25%;
        margin: 10px 20px;
    }
    
    @media (max-width: 700px) {
        width: 40%;
        margin: 10px;
    }
`;

const FeaturedPublications = ({
	title = 'As Featured In',
	titleColor = '#5d6c81',
	lineColor = '#5d6c81',
	logoFilter,
	logos = [{
		src: 'https://images.ctfassets.net/cdyxtpbavd4i/0NVGrbaSm88xMK1xZO5qD/93069134fd71abc1062ffe76ab2a8f62/laweekly.svg',
		title: 'LA Weekly'
	},
	{
		src: 'https://images.ctfassets.net/cdyxtpbavd4i/27hbQom70OLASBf7fVxKZU/97c097d7eafba4b973706ef26a33efcd/TheHuffingtonPost.svg',
		title: 'The Huffington Post'
	},
	{
		src: 'https://images.ctfassets.net/cdyxtpbavd4i/5iCeAZ2nJ1QxoYxl3RZ0ik/3df45c5735a3dea677b6e03a8b3441b8/TheWashingtonPost.svg',
		title: 'The Washington Post'
	},
	{
		src: 'https://images.ctfassets.net/cdyxtpbavd4i/5XXGtZ1wcYZ95SqaHLDlfd/6bea062091481f2b1a5c5b867272929f/TheGuardian.svg',
		title: 'The Guardian'
	},
	{
		src: 'https://images.ctfassets.net/cdyxtpbavd4i/6E4iiFIdba4gmpAvbi8VEh/39a1d90f5233278018de35af1b910b85/DailyNews.svg',
		title: 'Daily News'
	},
	{
		src: 'https://images.ctfassets.net/cdyxtpbavd4i/dPcqSuDyiEeoo9LcYX0Eg/c4300918524175d06342efdbbb26794d/DailyBeast.svg',
		title: 'Daily Beast'
	},
	{
		src: 'https://images.ctfassets.net/cdyxtpbavd4i/78XgcX04sfmPMim6jkoVn1/0df98a8bd221ebb610f8745e5425d90c/forbes.svg',
		title: 'Forbes'
	},
	{
		src: 'https://images.ctfassets.net/cdyxtpbavd4i/6pGIALjgkOQ9HjCISN7WpP/1d43fdf51cc8ee265b2e81b32e69b5b0/rollingstone.svg',
		title: 'Rolling Stone'
	},
	{
		src: 'https://images.ctfassets.net/cdyxtpbavd4i/6wgyGgUOuungGPYvy1Mxgz/c5528801757194f0a975c711c3bc1f2d/esquire.svg',
		title: 'Esquire'
	},
	{
		src: 'https://images.ctfassets.net/cdyxtpbavd4i/PORXZK3f5E6x5py3wG37r/d3fb0037be5f8f593db2133fa1d59ba0/Maxim.svg',
		title: 'Maxim'
	},
	{
		src: 'https://images.ctfassets.net/cdyxtpbavd4i/2FHdIsISt3XeBJYSkrPUb3/88986de6615822140046795e64044ee0/Vice.svg',
		title: 'Vice'
	},
	{
		src: 'https://images.ctfassets.net/cdyxtpbavd4i/5QhZZ3QpXFr4fftFJir0Xu/73bbe6741241e6f2564b48525b4082b0/TheSun.svg',
		title: 'The Sun'
	}
	]
}) => (
	<FeaturedPublicationsWrapper>
		<TitleWrapper>
			<Line lineColor={lineColor} /><Title dangerouslySetInnerHTML={{ __html: title }} titleColor={titleColor} /><Line lineColor={lineColor} />
		</TitleWrapper>
		<SectionWrapper>
			{logos.map((l, pos) => {
				if (l.src) {
					l.src = l.src.replace("images.ctfassets.net", "ctf-images.gammacdn.com");
				}
				return <Logo src={l.src} alt={l.title} title={l.title} logoFilter={logoFilter} key={pos} />
			})}
		</SectionWrapper>
	</FeaturedPublicationsWrapper>
);

export default FeaturedPublications;
